var htmlcoinjs = require('bitcoinjs-lib')

Object.assign(htmlcoinjs.networks, require('./networks'))

htmlcoinjs.utils = require('./utils')

module.exports = htmlcoinjs



//////////////////
// WEBPACK FOOTER
// ./~/htmlcoinjs-lib/src/index.js
// module id = LbyV
// module chunks = 0